import { Component, input } from '@angular/core';
import { MatError } from '@angular/material/form-field';
import { AbstractControl, FormGroup } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-form-error',
  imports: [MatError, TranslocoDirective],
  templateUrl: './dialog-form-error.component.html'
})
export class DialogFormErrorComponent {
  control = input.required<AbstractControl>();

  getErrors(control: AbstractControl): string[] {
    const allErrors = new Set<string>();

    if (control.errors) {
      Object.keys(control.errors).forEach(allErrors.add, allErrors);
    }

    if (control instanceof FormGroup) {
      const formGroup = control;

      Object.keys(formGroup.controls).forEach((key) => {
        const field = formGroup.controls[key];
        this.getErrors(field).forEach(allErrors.add, allErrors);
      });
    }

    return [...allErrors];
  }
}
